<template>
  <v-main class="whiteSmoke">
    <TheSidebar @input="toggleSidebar" ref="sidebar" />
    <TheToolbar @click="toggleSidebar" :requestUserData="requestUserData">
      <slot name="breadcrumb" />
    </TheToolbar>
    <ToolbarBreadcrumbMobile class="toolbar-mobile">
      <slot name="breadcrumb-mobile" />
    </ToolbarBreadcrumbMobile>
    <TheAlert v-model="alertNotification" />
    <slot name="toolbar" />
    <v-container
      app
      class="py-8 max-content-width"
      v-if="getUser"
    >
      <div class="px-0">
        <slot />
      </div>
    </v-container>
    <LoadingModal />
  </v-main>
</template>
<script>
import TheAlert from "@/components/TheAlert";
import LoadingModal from "@/components/LoadingModal";
import { mapState, mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
export default {
  name: "Main",
  data: () => ({
    drawer: true,
    getUser: false
  }),
  props: {
    requestUserData: {
      type: Boolean,
      default: true
    }
  },
  components: {
    TheAlert,
    LoadingModal
  },
  mixins: [LoadingRequest],
  created() {
    // Tratativas de erro 403 (sem permissão)
    // serão feitas no axios
    this.fetchUserPermissions();
  },
  computed: {
    ...mapState(["alertNotification", "loadingStatus", "userPermissions"]),
    ...mapState("me", ["userIsGuest"])
  },
  methods: {
    ...mapActions(["requestUserPermissions", "showAlertNotification"]),
    toggleSidebar() {
      let drawerRef = this.$refs.sidebar;
      drawerRef.drawer = !drawerRef.drawer;
    },
    fetchUserPermissions() {
      if (this.requestUserData) {
        this.requestUserPermissions();
      }
    },
    checkUserPermissions(value) {
      if (this.$route.meta.permissionRoute) {
        const enableView = value.acoes.find(
          x => x.id === this.$route.meta.permissionRoute
        );
        if (enableView) {
          this.getUser = true;
        } else {
          this.showAlertNotification({
            message: "Usuário sem permissão para acessar a página",
            type: "error"
          });
          this.$router.push({ name: "quotation" });
        }
      } else {
        this.getUser = true;
      }
    }
  },
  watch: {
    userPermissions(value) {
      this.checkUserPermissions(value);
    }
  }
};
</script>
<style lang="sass">
.max-content-width
  @media (min-width: 600px)
    width: 100% !important
    max-width: none !important
    margin: 0 auto
.toolbar-mobile
  display: none
  @media (max-width: 600px)
    display: block
</style>
